import { api } from "../../api";

const byEmail = (email: string) =>
  api.get(`usuario/buscarUsuarioPorEmail?email=${email}`);

const findAll = () => api.get(`funcionario/listarTodos`);

const extract = (id?: number) =>
  api.get(`meritoFuncionario/extrato?idFuncionario=${id}`);

const extratoAllFuncionarios = () =>
  api.get(`meritoFuncionario/extratoAllFuncionarios`);

const extratoGestores = () =>
  api.get(`meritoFuncionario/extratoGestores`);

const byDepartment = (ids?: any) =>
  api.post(`funcionario/buscarFuncionarioPorIdDepartamento`,ids);

const extractAdm = () => api.get("carga/extrato");

const departamentByEmail = (email: string) =>
  api.get(`usuario/buscarDepartamentosUsuarioPorEmail?email=${email}`);

const gestorByDepartment = (id?: number) =>
  api.get(
    `funcionario/buscarFuncionarioDistribuidoresPorIdDepartamento?idDepartamento=${id}`
  );

const gestor = () => 
  api.get('funcionario/buscarFuncionarioDistribuidores');

export const employee = {
  byEmail,
  findAll,
  extract,
  extratoAllFuncionarios,
  extratoGestores,
  byDepartment,
  extractAdm,
  gestorByDepartment,
  departamentByEmail,
  gestor,
};
